import {
  ObjectSchema,
  SchemaDescription,
  SchemaFieldDescription,
  SchemaObjectDescription,
} from 'yup';

export const isFormFieldRequired = (
  name: string,
  schema?: ObjectSchema<object>,
  dependentFieldValues?: Record<string, unknown>,
): boolean => {
  if (!schema) {
    return false;
  }
  const nameParts = name.split('.');
  const parsedName = nameParts[0];
  const fieldName = nameParts[nameParts.length - 1];
  const fields = schema?.describe({ value: dependentFieldValues }).fields;
  const currentField = fields[parsedName] as SchemaDescription;

  const isRequired = testField(currentField);
  if (isRequired) {
    return true;
  }
  if (fields[parsedName]?.type === 'object') {
    const field = fields[parsedName] as SchemaObjectDescription;
    const innerFields = field.fields;

    return testField(findFieldInNestedObject(innerFields, fieldName) as SchemaDescription);
  }
  return false;
};

const findFieldInNestedObject = (
  obj: Record<string, SchemaFieldDescription>,
  name: string,
): SchemaFieldDescription | null => {
  if (!obj) return null;

  for (const key in obj) {
    if (key === name) return obj[key];

    if (typeof obj[key] === 'object') {
      const innerField = (obj[key] as SchemaObjectDescription).fields;
      const found = findFieldInNestedObject(innerField, name);
      if (found) return found;
    }

    if (Array.isArray(obj[key])) {
      const found = obj[key].find((item: any) => item.name === name);
      if (found) return found;
    }
  }

  return null;
};

const testField = (field?: SchemaDescription) => {
  if (!field) {
    return false;
  }
  return Boolean(field.tests.find(t => t.name === 'required')) || !field.optional;
};
